// Normalizes a timestamp field that may be a plain number (legacy records
// written with Date.now()) or a Firestore Timestamp object (current records
// written with serverTimestamp()). Returns milliseconds since epoch, or 0
// if the input is neither shape.
export const toMillis = (ts) => {
  if (typeof ts === 'number') return ts;
  if (ts?.toMillis) return ts.toMillis();
  return 0;
};
